/**
 * Internal dependencies
 */
import { StyledSpinner } from './styles/spinner-styles';

export default function Spinner() {
	return <StyledSpinner className="components-spinner" />;
}
